// tslint:disable:max-line-length
export const SalesPackTabConstants = {
  SalesPackGeneratingMarkup: `<html>
<head>
  <style type="text/css">
    svg {
      font-size: 2em;
      animation-name: spin;
      animation-duration: 2s;
      animation-iteration-count: infinite;
      animation-timing-function: linear;
    }

    #page-container {
      height: 100%;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    #spinner-container {
      display: flex;
      flex-direction: column;
      gap: 1rem;
      font-family: "Exo", Arial, sans-serif;
    }

    @keyframes spin {
      0% {
        transform: rotate(0deg)
      }
      
      100% {
        transform: rotate(360deg)
      }
    }
  </style>
</head>
<body>
  <div id="page-container">
    <div id="spinner-container">
      <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM48 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm464-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM142.9 437A48 48 0 1 0 75 369.1 48 48 0 1 0 142.9 437zm0-294.2A48 48 0 1 0 75 75a48 48 0 1 0 67.9 67.9zM369.1 437A48 48 0 1 0 437 369.1 48 48 0 1 0 369.1 437z"/>
      </svg>
      Generating Pack, please wait...
    </div>
  </div>
</body>
</html>`
};
